import { FieldInputProps } from "formik";
import { NumericFormat, NumberFormatValues } from "react-number-format";

interface CurrencyCellProps extends FieldInputProps<any> {
  currencySymbol?: string;
  startAdornment?: string;
  hasError?: boolean;
}

const CustomInput = ({
  startAdornment,
  value,
  name,
  onBlur,
  ...props
}: any) => (
  <div
    className={`w-full flex flex-row items-center rounded-md outline-none transition-all duration-200 group focus-within:bg-gray-100 py-1 px-2 ${
      props.hasError ? "placeholder-red-500" : ""
    }`}
  >
    {startAdornment && <span className="flex-shrink-0">{startAdornment}</span>}
    <input
      {...props}
      name={name}
      value={value}
      onBlur={onBlur}
      className="w-full outline-none bg-transparent"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          onBlur(e as unknown as React.FocusEvent<HTMLInputElement>);
        }
      }}
      placeholder={props.hasError ? "*Required" : ""}
    />
  </div>
);

const CurrencyCell = ({
  currencySymbol = "$",
  name,
  value,
  onChange,
  onBlur,
  ...props
}: CurrencyCellProps) => {
  const handleValueChange = (values: NumberFormatValues) => {
    onChange({
      target: {
        name,
        value: values?.floatValue ?? null,
      },
    });
  };

  return (
    <NumericFormat
      name={name}
      customInput={CustomInput}
      valueIsNumericString={true}
      thousandSeparator={true}
      value={value}
      decimalScale={2}
      fixedDecimalScale={true}
      onValueChange={handleValueChange}
      startAdornment={currencySymbol}
      allowLeadingZeros={false}
      allowNegative={false}
      {...props}
      onBlur={onBlur}
    />
  );
};

export default CurrencyCell;
